import styled from 'styled-components'

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items:center;
  justify-content: center;
  gap:1rem;
  button {
    min-width:fit-content;
  }
`;

export const TableContent = styled.div`
  width: 100%;
  display: flex;
  place-items:center;
  margin-top: 2rem;
  /* max-width: 600px; */
  div.MuiPaper-root {
    width: 100%!important;
  }
`;
export const CreateContent = styled.div`
  width: 100%;
  display: flex;
  justify-content:center;
  align-items:flex-end;
  gap:1rem;
  margin-top: 1rem;
  
`;
export const BoxLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  width: 100%;
  position:relative;
  height: 100%;
  margin-top: 2rem;
  p {
    font-size:1.2rem;
    color: #a6a6a6;
    text-align:center;
    width: 100%;
  }
`;